import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CounsellorsComponent} from './counsellors.component';
import {AddCounsellorComponent} from './add-counsellor/add-counsellor.component';

const routes: Routes = [
    {
        path: 'counsellors',
        component:CounsellorsComponent,
        data: {animation: 'counsellors'}
    },
    {
        path: 'counsellor/add',
        component: AddCounsellorComponent,
        data: {animation: 'counsellor/add'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CounsellorsRoutingModule {
}
